import React, { useContext, useState } from 'react';
import {Stack, Icon, Tooltip} from '@shopify/polaris';
import {DeleteMinor, DragHandleMinor, CirclePlusOutlineMinor, CirclePlusMinor} from '@shopify/polaris-icons';
import {TextField} from '@thinkwell/react.polaris';
import EditNodeDrop from './EditNodeDrop'
import { useDrag } from 'react-dnd';
import CourseTree from '../models/CourseTree';
import EditContainer from './EditContainer';
import EditContent from './EditContent';
import {CourseTreeContext} from '../contexts/CourseTree'
import axios from 'axios'

export default function EditNode(props) {
  const [courseTree, updateCourseTree, isOpen, toggleOpen] = useContext(CourseTreeContext)

  const {id, number, name, parent_node_id, parent_node_type, position, course_tree_id, type, child_nodes} = props.item

  const onDeleteNode = async() => {
    if (window.confirm(`Do you really want to remove ${name}?`)) {
      axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector("meta[name=csrf-token]").content
      await axios({method: 'delete', url: `/nodes/${id}.json`})
      courseTree.removeNode(id)
      updateCourseTree(courseTree)
    }
  }

  const onAddNode = (node) => {
    courseTree.addNode(props.item, node, node.position)
    if (!isOpen(id)) {
      toggleOpen(id)
    }
    updateCourseTree(courseTree)
  }

  return (
    <div>
      <div className="edit-node">
        <div className={`edit-node`}>
          <span className="drag-icon"><Icon source={DragHandleMinor} /></span>
          { type == 'container' ?
            <EditContainer linkText={`${number} ${name}`} title={`Edit ${name}`} item={props.item}/>
             : null
          }
          { type == 'content' ?
            <EditContent linkText={name} title={`Edit ${name}`} item={props.item}/>
            : null
          }
          { type == 'container' ?
            [<EditContainer
              key="add_container"
              onSave={onAddNode}
              linkText={<span title="Add a container"><Icon source={CirclePlusMinor} /></span>}
              title={`Add container`}
              item={{
                parent_node_id: id,
                parent_node_type: 'Node',
                position: child_nodes && child_nodes.length || 0,
                course_tree_id: course_tree_id
              }}/>,
            <EditContent
              key="add_content"
              onSave={onAddNode}
              linkText={<span title="Add content"><Icon source={CirclePlusOutlineMinor} /></span>}
              title={`Add content`}
              item={{
                parent_node_id: id,
                parent_node_type: 'Node',
                position: child_nodes && child_nodes.length || 0,
                course_tree_id: course_tree_id
              }}/>] : null
            }
          <span className="delete-icon" onClick={onDeleteNode} title="Delete the node"><Icon source={DeleteMinor} /></span>
        </div>
      </div>
    </div>
  );
}
